/* WC — Extras: hide captcha badge, video observers, empty promo cleaner, quicklink init, autoplay priming */
(function () {
  'use strict';

  /* ---------- Ensure autoplay-friendly video attributes (mute + playsinline) ---------- */
  function primeAutoplayVideos(scope) {
    try {
      var root = scope || document;
      var vids = root.querySelectorAll('video[autoplay]');
      for (var i = 0; i < vids.length; i++) {
        var v = vids[i];
        // Make autoplay more likely across browsers (iOS requires muted + playsinline)
        v.muted = true;
        try { v.setAttribute('muted', ''); } catch (e) {}
        v.playsInline = true;
        try {
          v.setAttribute('playsinline', '');
          v.setAttribute('webkit-playsinline', '');
        } catch (e) {}
        // Try to start if already in view; observers below will manage pause/resume
        try {
          v.play().catch(function () { /* ignore */ });
        } catch (e) {}
      }
    } catch (_) {}
  }

  /* ---------- Hide Shopify hCaptcha badge ---------- */
  function hideCaptcha() {
    var el = document.getElementById('shop-hcaptcha-badge-container');
    if (!el) return;
    el.style.display = 'none';
    el.style.visibility = 'hidden';
    el.style.opacity = '0';
    el.style.pointerEvents = 'none';
    el.style.position = 'absolute';
    el.style.left = '-100000px';
    el.style.zIndex = '-999999';
  }

  document.addEventListener('DOMContentLoaded', function () {
    primeAutoplayVideos(document);
    hideCaptcha();
  });

  new MutationObserver(function () {
    hideCaptcha();
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Small exponential backoff just in case late injections appear
  (function backoffHide(times, delay) {
    hideCaptcha();
    if (times <= 0) return;
    setTimeout(function () {
      backoffHide(times - 1, Math.min(delay * 2, 8000));
    }, delay);
  })(5, 500);

  /* ---------- Video observers ---------- */
  function autoplayOnceObserver(scope) {
    if (!('IntersectionObserver' in window)) return;
    var root = scope || document;
    var videos = root.querySelectorAll('video[autoplay]:not([loop])');
    if (!videos.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (v.ended || v.paused) {
            try {
              v.currentTime = 0;
              v.play();
            } catch (e) {}
          }
        } else {
          if (!v.paused) {
            try { v.pause(); } catch (e) {}
          }
        }
      });
    }, { threshold: 0.15 });

    for (var i = 0; i < videos.length; i++) io.observe(videos[i]);
  }

  function autoplayLoopObserver(scope) {
    if (!('IntersectionObserver' in window)) return;
    var root = scope || document;
    var videos = root.querySelectorAll('video[autoplay][loop]');
    if (!videos.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (v.paused) {
            try { v.play(); } catch (e) {}
          }
        } else {
          if (!v.paused) {
            try { v.pause(); } catch (e) {}
          }
        }
      });
    }, { threshold: 0.15 });

    for (var i = 0; i < videos.length; i++) io.observe(videos[i]);
  }

  function productOverviewObserver(scope) {
    if (!('IntersectionObserver' in window)) return;
    var root = scope || document;
    var wraps = root.querySelectorAll('.product-overview-video-wrapper');
    if (!wraps.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var wrap = entry.target;
        var video = wrap.querySelector('video');
        if (!video) return;

        var shouldLoop = (wrap.getAttribute('data-loop') === 'true');
        video.loop = !!shouldLoop;

        if (entry.isIntersecting) {
          try { video.play(); } catch (e) {}
        } else {
          try { video.pause(); } catch (e) {}
          if (!shouldLoop) {
            try { video.currentTime = 0; } catch (e) {}
          }
        }
      });
    }, { threshold: 0.5 });

    for (var i = 0; i < wraps.length; i++) {
      var v = wraps[i].querySelector('video');
      if (v && (wraps[i].getAttribute('data-loop') !== 'true')) {
        v.addEventListener('ended', function () {
          try {
            this.pause();
            this.currentTime = 0;
          } catch (e) {}
        });
      }
      io.observe(wraps[i]);
    }
  }

  function initVideos(scope) {
    primeAutoplayVideos(scope || document);
    autoplayOnceObserver(scope);
    autoplayLoopObserver(scope);
    productOverviewObserver(scope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initVideos(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initVideos(e.target || document);
  });

  document.addEventListener('shopify:section:select', function (e) {
    initVideos(e.target || document);
  });

  /* ---------- Hide empty promo tiles ---------- */
  function reallyHideEmptyPromos() {
    var nodes = document.querySelectorAll('.promotion-grid-item__promotion-container');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var hasText = !!el.textContent.replace(/\s/g, '').length;
      if (!hasText && el.offsetHeight < 5) {
        el.style.display = 'none';
      } else {
        el.style.display = '';
      }
    }
  }

  document.addEventListener('DOMContentLoaded', reallyHideEmptyPromos);

  new MutationObserver(reallyHideEmptyPromos).observe(document.body, {
    childList: true,
    subtree: true
  });

  setTimeout(reallyHideEmptyPromos, 500);
  setTimeout(reallyHideEmptyPromos, 1500);
  setTimeout(reallyHideEmptyPromos, 3500);

  /* ---------- Quicklink init (race-safe + dedup) ---------- */
  var INIT_FLAG = '__QL_INITED';

  function tryInitQuicklink() {
    if (window[INIT_FLAG]) return; // prevent double init
    if (!window.quicklink || !window.quicklink.listen) return;

    window[INIT_FLAG] = true;
    try {
      window.quicklink.listen({
        ignores: [
          function (uri, elem) {
            return (
              (elem && elem.classList && (
                elem.classList.contains('cart-link') ||
                elem.classList.contains('drawer-trigger') ||
                elem.classList.contains('header__icon-touch--search')
              )) ||
              uri.pathname === '/cart' ||
              uri.pathname === '/account' ||
              uri.pathname === '/search'
            );
          }
        ]
      });
    } catch (e) {}
  }

  // Fire once on load, plus a short poll if the CDN is late
  window.addEventListener('load', tryInitQuicklink, { once: true });

  var qlTimer = setInterval(function () {
    if (window.quicklink && window.quicklink.listen) {
      tryInitQuicklink();
      clearInterval(qlTimer);
    }
  }, 500);

  setTimeout(function () {
    try {
      clearInterval(qlTimer);
    } catch (e) {}
  }, 8000);
})();
